 
 
import React, { useCallback, useEffect, useMemo } from 'react';
import Api from '../../api';
import { isProd } from '../../utils/helpers';

interface ErrorProps {
  children?: React.ReactNode;
}
const ErrorBoundary: React.FC<ErrorProps> = ({ children }) => {
  const ignored = useMemo(() => ['ResizeObserver'], []);
  const onError = useCallback(
    (error: ErrorEvent) => {
      if (ignored.some((i) => error.message.match(`${i}`))) {
        console.warn({ Ignored: error });
        return;
      }
      console.error(error);
      Api.Log.Error(error.error || error);
      if (isProd()) window.location.href = '/error/500';
    },
    [ignored]
  );
  useEffect(() => {
    window.addEventListener('error', onError);
    return () => {
      window.removeEventListener('error', onError);
    };
  }, [onError]);
  return <>{children}</>;
};
export default ErrorBoundary;
